
(function() {
  var result = { translations: { "en": null } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "signup-ui-lego": {
    "da": "static-1.10095",
    "de": "static-1.10095",
    "en": "static-1.10095",
    "es": "static-1.10095",
    "fi": "static-1.10095",
    "fr": "static-1.10095",
    "it": "static-1.10095",
    "ja": "static-1.10095",
    "nl": "static-1.10095",
    "no": "static-1.10095",
    "pl": "static-1.10095",
    "pt-br": "static-1.10095",
    "sv": "static-1.10095",
    "zh-tw": "static-1.10095"
  }
};
  hns('I18n', result);

})();


